import moment from 'moment-timezone'

moment.locale('pt-br')

export const formatDateTime = value => {
  if (value) {
    return moment.tz(value, 'America/Sao_Paulo').format('DD/MM/YYYY HH:mm')
  }

  return ''
}

export const formatDate = value => {
  if (value) {
    return moment.tz(value, 'America/Sao_Paulo').format('DD/MM/YYYY')
  }

  return ''
}

export const formatTime = value => {
  if (value) {
    return moment.tz(value, 'America/Sao_Paulo').format('HH:mm')
  }

  return ''
}
